module.exports = __webpack_public_path__ + "static/media/on_net.8acec175.svg";